import GeneratedHttpThunk from 'utility/redux/generatedHttpThunk';

const siteHealthMonthRangeHttpRequest = (() => {
  const apiName = 'siteHealthMonthRange';
  const generatedHttpThunk = new GeneratedHttpThunk(apiName);
  generatedHttpThunk.resource = `filter/month-range`;
  return generatedHttpThunk.generatePortfolioThunk();
})();

export default siteHealthMonthRangeHttpRequest;
